// src/features/rrhh/mensajeria/components/MensajesFilters.jsx
import { Box, Button, Stack, Typography } from "@mui/material";

function TabBtn({ active, children, onClick }) {
  return (
    <Button
      onClick={onClick}
      disableRipple
      sx={{
        px: 1,
        py: 1,
        borderRadius: 999,
        textTransform: "none",
        width: "14vw",
        bgcolor: active ? (t) => t.palette?.secondary?.[200] : (t) => t.palette?.secondary?.[100],
        border: active ? "2px solid rgba(20, 30, 60, 0.4)" : "1px solid transparent",
        boxShadow: active
          ? "inset 0px 0px 4px rgba(120, 120, 140, 0.45)"
          : "inset 0px 0px 3px rgba(142, 142, 159, 0.45)",
        "&:hover": {
          bgcolor: active ? (t) => t.palette?.secondary?.[300] : (t) => t.palette?.secondary?.[200],
        },
      }}
    >
      <Typography sx={{ fontSize: 14, fontWeight: 600, color: (t) => t.palette?.primary?.[900] }}>
        {children}
      </Typography>
    </Button>
  );
}

export default function MensajesFilters({ view = "list", setView }) {
  const goNew = () => {
    setView(view === "new" ? "list" : "new");
  };
  
  const goSearch = () => {
    setView(view === "search" ? "list" : "search");
  };
  return (
    <Box
      sx={{
        p: 1,
        borderRadius: "20px",
        bgcolor: (t) => t.palette?.neutral?.[50],
        boxShadow: "inset 0px 0px 2px rgba(96, 96, 113, 0.45)",
      }}
    >
      <Stack direction="row" spacing={1.25} alignItems="center">
        <TabBtn active={view === "new"} onClick={goNew}>
          Enviar nuevo mensaje
        </TabBtn>

        <TabBtn active={view === "search"} onClick={goSearch}>
          Buscar Mensaje
        </TabBtn>
      </Stack>
    </Box>
  );
}
